import { render, staticRenderFns } from "./passhot.vue?vue&type=template&id=53c3f4f3&scoped=true&"
import script from "./passhot.vue?vue&type=script&lang=js&"
export * from "./passhot.vue?vue&type=script&lang=js&"
import style0 from "./passhot.vue?vue&type=style&index=0&id=53c3f4f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c3f4f3",
  null
  
)

export default component.exports